import { IAppointment } from '@pia/pia.shared';
import { Injectable } from '@angular/core';
import { AppointmentWorkItem } from 'src/app/business/appointment/appointment-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class AppointmentCommandHandler extends EntityCommandHandler<IAppointment> {
  protected workItem: IWorkItem<IAppointment>;

  constructor(appointmentWorkItem: AppointmentWorkItem) {
    super();
    this.workItem = appointmentWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'AppointmentDto';
  }
}
